import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared split-screen layout for /login, /signup, /verify-email, /complete-profile.
 * Left: immersive dark-blue panel with logo + marketing copy.
 * Right: form area (children).
 */
export default function AuthLayout({ children, title, subtitle, sideTitle, sideBullets }) {
  return (
    <div className="min-h-screen bg-[#0A1530] text-slate-100 flex">
      {/* Left panel — hidden on mobile */}
      <div className="hidden lg:flex w-[42%] relative overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(1200px 600px at 10% 10%, rgba(56,189,248,0.15), transparent 60%)," +
              "radial-gradient(900px 500px at 90% 90%, rgba(168,85,247,0.18), transparent 55%)," +
              "linear-gradient(180deg, #0B1735 0%, #0A1428 100%)",
          }}
        />
        {/* Grain */}
        <div
          aria-hidden
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "radial-gradient(rgba(255,255,255,0.7) 1px, transparent 1px)",
            backgroundSize: "3px 3px",
          }}
        />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <Link to="/" className="flex items-center gap-3 group" data-testid="auth-layout-logo-link">
            <img src="/Tots360_logo.png" alt="tots360" className="h-12 w-auto" />
          </Link>

          <div className="max-w-md">
            <h2 className="text-4xl font-semibold leading-tight">{sideTitle}</h2>
            <ul className="mt-8 space-y-4 text-slate-300">
              {(sideBullets || []).map((b, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-2 w-1.5 h-1.5 rounded-full bg-sky-400 flex-shrink-0" />
                  <span className="text-[15px] leading-relaxed">{b}</span>
                </li>
              ))}
            </ul>
          </div>

          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Rev & Dev Children Clinic. A HIPAA-aligned, consent-first platform.
          </p>
        </div>
      </div>

      {/* Right panel — form */}
      <div className="flex-1 flex flex-col">
        <div className="lg:hidden px-6 pt-6">
          <Link to="/" className="inline-flex" data-testid="auth-layout-logo-mobile">
            <img src="/Tots360_logo.png" alt="tots360" className="h-10 w-auto" />
          </Link>
        </div>
        <div className="flex-1 flex items-center justify-center px-6 py-12">
          <div className="w-full max-w-md">
            {title && (
              <h1 className="text-3xl font-semibold tracking-tight" data-testid="auth-title">
                {title}
              </h1>
            )}
            {subtitle && <p className="mt-2 text-sm text-slate-400">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
